module.exports = __webpack_public_path__ + "media/notification.43d5a4f2.wav";